import {
    DL_GET_ALL_301_REDIRECTS,
    DL_GET_301_REDIRECTS_PAGINATED,
    DL_GET_301_REDIRECTS_PAGINATED_ERROR,
    DL_GET_301_REDIRECTS_COUNT,
    DL_GET_301_REDIRECTS_COUNT_ERROR,
    DL_ALL_301_REDIRECTS_ERROR,
    DL_ADD_301_REDIRECTS_BULK,
    DL_ADD_301_REDIRECTS_BULK_ERROR,
    DL_ADD_301_REDIRECT,
    DL_ADD_301_REDIRECT_ERROR
} from "../actions/types";

const initialState = {
    Page301redirects: [],
    paginated301Redirects: [],
    count: null,
    isLoading: true,
    success: false,
};

export default function (state = initialState, action) {
    const { payload, type } = action;

    switch (type) {
        case DL_GET_ALL_301_REDIRECTS:
            return {
                ...state,
                Page301redirects: payload,
                isLoading: false,
                success: true,
            };
        case DL_GET_301_REDIRECTS_PAGINATED:
            return {
                ...state,
                paginated301Redirects: payload,
                isLoading: false,
                success: true,
            };
        case DL_GET_301_REDIRECTS_COUNT:
            return {
                ...state,
                count: payload,
                isLoading: false,
                success: true,
            };
        case DL_ADD_301_REDIRECTS_BULK:
        case DL_ADD_301_REDIRECT:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        case DL_ADD_301_REDIRECTS_BULK_ERROR:
        case DL_ADD_301_REDIRECT_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
            };
        case DL_ALL_301_REDIRECTS_ERROR:
            return {
                ...state,
                Page301redirects: payload,
                isLoading: false,
                success: false,
            };
        case DL_GET_301_REDIRECTS_PAGINATED_ERROR:
            return {
                ...state,
                paginated301Redirects: [],
                isLoading: false,
                success: false,
            };
        case DL_GET_301_REDIRECTS_COUNT_ERROR:
            return {
                ...state,
                count: null,
                isLoading: false,
                success: false,
            };
        default:
            return state;
    }
}
